// Shared CSV / formatting helpers used across MEC drill-down + queue pages.
//
// Frontend-side CSV generation (no backend round-trip) — the rows are
// already in memory and we don't want to maintain a CSV endpoint per list.

export function escapeCsvField(value) {
  if (value == null) return '';
  const str = String(value);
  // Quote if contains comma, quote, newline, or CR.
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function rowsToCsv(rows, columns) {
  // columns: [{ key, label, accessor?(row) → value }]
  const header = columns.map((c) => escapeCsvField(c.label)).join(',');
  const lines = rows.map((r) =>
    columns
      .map((c) => escapeCsvField(c.accessor ? c.accessor(r) : r[c.key]))
      .join(',')
  );
  return [header, ...lines].join('\n');
}

export function downloadCsv(filename, csvText) {
  const blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Defer revoke so Safari completes the download.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Cents → $X.XX (no thousand sep when used in CSV — keep machine-friendly).
export function centsToDollarsRaw(cents) {
  if (cents == null) return '';
  return (cents / 100).toFixed(2);
}
